import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const painPoints = ['Domingo buscando qué publicar sin encontrar nada', 'La competencia publica todos los días y vos no', 'Reels que no venden porque no tienen estructura', 'DMs sin respuesta porque no tenés sistema de cierre', 'Stock parado porque no sabés cómo mostrarlo', 'Cobrando lo mismo que hace 6 meses', 'El lunes llega y el ciclo se repite igual'];
export function ProblemSection() {
  return <section className="w-full py-14 px-4 bg-base relative" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-201">
          <h2 className="text-4xl md:text-5xl font-extrabold text-text-main mb-8 leading-tight" data-id="element-202">
            ¿Cuántas noches más vas a quedarte sin saber qué publicar mañana?
          </h2>
          <p className="text-xl text-text-muted max-w-3xl mx-auto leading-relaxed" data-id="element-203">
            Amás tu negocio pero terminás los domingos a las 11 de la noche
            mirando el teléfono buscando inspiración para el próximo Reel.
            <br data-id="element-204" />
            <br data-id="element-205" />
            <span className="text-text-main font-semibold" data-id="element-206">
              No es falta de ganas. Es falta de un sistema.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-alt border border-primary/20 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-207">
          {/* Subtle background glow in the panel */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl" data-id="element-208" />

          <ul className="space-y-6 relative z-10" data-id="element-209">
            {painPoints.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-210">
                <div className="mt-1 flex-shrink-0 bg-red-500/10 p-1 rounded-full" data-id="element-211">
                  <X size={20} className="text-red-400" data-id="element-212" />
                </div>
                <span className="text-lg text-text-main" data-id="element-213">{point}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-214">
          <h3 className="text-3xl md:text-4xl font-bold text-primary" data-id="element-215">
            ¿Y si este fuera el último domingo que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}